import { clientCookie } from './clientCookie';

// Cookie gravado no momento em que o usuário ENTRA na loja de moedas. Guarda o
// profileId e o userState "originais" (os mesmos usados para calcular o preço
// dos bundles) para que, na hora da compra, possamos comparar com o userState
// que está sendo efetivamente enviado. Ver [logBundlePrice].
export const STORE_ENTRY_STATE_COOKIE_NAME = 'gn_store_entry_state';
export const STORE_ENTRY_STATE_COOKIE_TTL_DAYS = 1;

export interface IStoreEntryState {
  profileId: string | number;
  userState: string;
}

export function saveStoreEntryState(data: IStoreEntryState): void {
  clientCookie.set(
    STORE_ENTRY_STATE_COOKIE_NAME,
    encodeURIComponent(JSON.stringify(data)),
    STORE_ENTRY_STATE_COOKIE_TTL_DAYS
  );
}

export function readStoreEntryState(): IStoreEntryState | null {
  const raw = clientCookie.get(STORE_ENTRY_STATE_COOKIE_NAME);

  if (!raw) return null;

  try {
    const parsed = JSON.parse(decodeURIComponent(raw));

    if (parsed?.profileId == null && parsed?.userState == null) {
      return null;
    }

    return parsed as IStoreEntryState;
  } catch {
    return null;
  }
}
